import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';
export default Object.freeze({
	GENERAL: `${RouteNames.CALENDARS}-general`,
	WORKING_WEEK: `${RouteNames.CALENDARS}-working-week`,
	HOLIDAYS: `${RouteNames.CALENDARS}-holidays`,
	SPECIAL_TIME: `${RouteNames.CALENDARS}-special-time`,
	PERMISSIONS: `${RouteNames.CALENDARS}-permissions`,
});
